export const SECRETARY_ROUTE_GUARD_TRANSLATIONS = {
  eyebrow: {
    "pt-BR": "Time administrativo",
    en: "Administrative team",
    es: "Equipo administrativo",
    de: "Verwaltungsteam",
  },
  title: {
    "pt-BR": "Sem permissão",
    en: "No permission",
    es: "Sin permiso",
    de: "Keine Erlaubnis",
  },
  subtitle: {
    "pt-BR":
      "Você não tem acesso a esta área. Peça ao profissional responsável para ajustar suas permissões.",
    en: "You do not have access to this area. Ask the responsible professional to adjust your permissions.",
    es: "No tienes acceso a esta área. Pide al profesional responsable que ajuste tus permisos.",
    de: "Sie haben keinen Zugriff auf diesen Bereich. Bitten Sie den zuständigen Fachmann, Ihre Berechtigungen anzupassen.",
  },
  backHome: {
    "pt-BR": "Voltar ao início",
    en: "Back to home",
    es: "Volver al inicio",
    de: "Zurück nach Hause",
  },
} as const;
